export enum PrivateMenuEntries {
  Profile = 'profile',
  Settings = 'settings',
  Forum = 'forum',
  Logout = 'logout',
}
